// @flow

import React from "react";

type Props = {
  all?: boolean,
  // utilities
  utilities?: boolean,
  loading?: boolean,
  crop?: boolean,
  search?: boolean,
  warning?: boolean,
  cross?: boolean,
  carat?: boolean,
  tick?: boolean,
  validationAlert?: boolean,
  filter?: boolean,
  edit?: boolean,
  cycle?: boolean,
  account?: boolean,
  // social
  social?: boolean,
  twitter?: boolean,
  email?: boolean,
  whatsapp?: boolean,
  facebook?: boolean,
  google?: boolean,
  instagram?: boolean,
  // loaders
  loaders?: boolean,
  loaderSMH?: boolean,
  loaderTheAge?: boolean,
  loaderWaToday?: boolean,
  loaderBrisbaneTimes?: boolean,
  loaderCT?: boolean
};

const SvgIcons = ({
  all,
  // utilities
  utilities,
  loading,
  crop,
  search,
  warning,
  cross,
  carat,
  tick,
  validationAlert,
  filter,
  edit,
  cycle,
  account,
  // social
  social,
  twitter,
  email,
  whatsapp,
  facebook,
  google,
  instagram,
  // loaders
  loaders,
  loaderSMH,
  loaderTheAge,
  loaderWaToday,
  loaderBrisbaneTimes,
  loaderCT
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ position: "absolute", width: 0, height: 0 }}
  >
    {/* Utilities */}
    {all || utilities || loading ? (
      <symbol viewBox="0 0 40 40" id="icon-loading">
        <circle
          className="loading__icon__circle"
          opacity="0"
          cx="15.8"
          cy="15"
          r="15"
        />
        <path
          d="M27.8084006,22.8842813 C29.5771785,20.6011257 30.6299412,17.7353365 
             30.6299412,14.6236613 C30.6299412,9.67647577 27.9688583,5.35081946 
             24,3"
          className="loading__icon__active-segment"
        />
      </symbol>
    ) : null}

    {all || utilities || crop ? (
      <symbol viewBox="0 0 60 60" id="icon-crop">
        <g>
          <path
            style={{
              strokeLinejoin: "round",
              stroke: "#ffffff",
              strokeLinecap: "round",
              stockWidth: 3.8108,
              fill: "none"
            }}
            transform="matrix(1.3121 0 0 1.3121 -3.3537 -16.138)"
            d="m14.216 17.353v27.891h28.971"
          />
          <path
            style={{
              stroke: "#ffffff",
              strokeLinecap: "round",
              stockWidth: 3.8108,
              fill: "none"
            }}
            transform="matrix(1.3121 0 0 1.3121 -37.824 -15.902)"
            d="m33.176 24.101h27.892v28.972"
          />
          <path
            style={{
              strokeLinejoin: "round",
              stroke: "#ffffff",
              strokeLinecap: "round",
              stockWidth: 3.8108,
              fill: "none"
            }}
            d="m14.542 44.739l26.756-26.396"
            transform="matrix(1.3121 0 0 1.3121 -3.3537 -16.138)"
          />
        </g>
      </symbol>
    ) : null}

    {all || utilities || search ? (
      <symbol viewBox="0 0 32 32" id="icon-search">
        <path
          d="M21.08 18.573l10.4 10.4a1.773 1.773 0 1 1-2.508 2.507l-10.4-10.4a11.62 11.62 0 0 1-6.902 2.26C5.225 23.34 0 18.115 0 11.67S5.225 0 11.67 0s11.67 5.225 11.67 11.67c0 2.583-.84 4.97-2.26 6.903zm-1.287-6.903a8.123 8.123 0 1 0-16.247 0 8.123 8.123 0 0 0 16.247 0z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}

    {all || utilities || warning ? (
      <symbol viewBox="0 0 32 32" id="icon-warning">
        <g>
          <path
            fill="gray"
            stroke="#fff"
            strokeWidth="2"
            d="m1,31c0,0 15,-30.5 15,-30l15,30c0.5,0 -30.5,0 -30,0z"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth="3"
            d="m16,13l0,10m0,2l0,2"
          />
        </g>
      </symbol>
    ) : null}

    {all || utilities || cross ? (
      <symbol viewBox="0 0 12 11" id="icon-cross">
        <g fill="currentColor" fillRule="evenodd">
          <path d="M9.183.903a1 1 0 011.414 1.414l-7.78 7.78a1 1 0 01-1.414-1.414l7.78-7.78z" />
          <path d="M1.524 2.317A1 1 0 012.938.903l7.78 7.78a1 1 0 01-1.414 1.414l-7.78-7.78z" />
        </g>
      </symbol>
    ) : null}
    {all || utilities || carat ? (
      <symbol viewBox="0 0 10 7" id="icon-carat">
        <path
          d="M1 1l4 3.74L9 1"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || utilities || carat ? (
      <marker
        viewBox="0 0 10 7"
        id="marker-increase-carat"
        markerWidth="15"
        markerHeight="10.5"
        refX="5"
        refY="3.5"
        orient="auto"
      >
        <path
          d="M1 1l4 3.74L9 1"
          stroke="currentColor"
          strokeWidth="0.75"
          fill="none"
          fillRule="evenodd"
          transform="rotate(90 5 3.5) translate(0 -1)"
        />
      </marker>
    ) : null}
    {all || utilities || tick ? (
      <symbol viewBox="0 0 11 11" id="icon-tick">
        <path
          d="M3.978 10a.998.998 0 01-.706-.294l-1.98-1.978a1 1 0 011.415-1.414L3.853 7.46l4.335-6.044a1 1 0 011.625 1.166l-5.022 7a.994.994 0 01-.813.418"
          fill="currentColor"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || utilities || validationAlert ? (
      <>
        <symbol viewBox="0 0 16 16" id="icon-validation-alert">
          <circle r="8" cx="8" cy="8" fill="currentColor" />
          <text
            textAnchor="middle"
            x="8"
            y="13"
            fill="#fff"
            style={{
              fontSize: "13px",
              fontWeight: 700,
              fontFamily: "'PT Sans', sans-serif"
            }}
          >
            !
          </text>
        </symbol>
        <symbol viewBox="0 0 16 16" id="icon-validation-alert-dark">
          <circle r="8" cx="8" cy="8" fill="currentColor" />
          <text
            textAnchor="middle"
            x="8"
            y="13"
            fill="#0a1633"
            style={{
              fontSize: "13px",
              fontWeight: 700,
              fontFamily: "'PT Sans', sans-serif"
            }}
          >
            !
          </text>
        </symbol>
      </>
    ) : null}
    {all || utilities || filter ? (
      <symbol viewBox="0 0 80 80" id="icon-filter">
        <path
          d="M42.0920658,31.3582862 L63.137384,5.55997982 L8.86261601,5.55997982 L30.1294639,31.3582862 C30.5725232,32.0254838 30.7940529,32.6926814 30.7940529,33.3598789 L30.7940529,56.489395 L41.2059471,61.6045764 L41.2059471,33.1374797 C41.2059471,32.4702822 41.6490065,31.8030846 42.0920658,31.3582862 Z M71.3339816,4.67038305 L46.9657184,34.2494757 L46.9657184,66.0525603 C46.9657184,68.2765522 44.7504218,69.6109474 42.9781845,68.7213506 L26.8065189,60.9373789 C25.9204002,60.4925805 25.0342816,59.6029837 25.0342816,58.2685886 L25.0342816,34.2494757 L0.666018394,4.67038305 C-0.884689263,2.89118951 0.444488729,0 2.88131505,0 L69.118685,0 C71.5555113,0 72.8846893,2.66879032 71.3339816,4.67038305 Z"
          transform="translate(4 6)"
          fill="currentColor"
          fillRule="nonzero"
        />
      </symbol>
    ) : null}

    {all || utilities || edit ? (
      <symbol viewBox="0 0 107 103" id="icon-edit">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M106.1 12.2L99 4.9c-.6-.6-1.4-.9-2.2-.9-.8 0-1.6.3-2.1.9L52.8 47.4c-.3.3-.5.6-.7 1l-4.7 11.9c-.4 1.1-.2 2.4.7 3.2.6.6 1.3.9 2.1.9.4 0 .7-.1 1.1-.2l11.8-4.7c.4-.2.7-.4 1-.7L106 16.3c1.3-1.1 1.3-3 .1-4.1z" />
          <path d="M87 45.6c-2.8 0-5 2.2-5 5V84H23V20h48.6c2.8 0 5-2.2 5-5s-2.2-5-5-5H18c-2.8 0-5 2.1-5 4.8V89c0 2.8 2.2 5 5 5h68.8c2.8 0 5.2-2.3 5.2-5V50.6c0-2.8-2.2-5-5-5z" />
        </g>
      </symbol>
    ) : null}
    {all || utilities || cycle ? (
      <symbol viewBox="0 0 46 48" id="icon-cycle">
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
          <g transform="translate(1 1)" fillRule="nonzero">
            <path
              d="M25.823 12.613l5.675-3.346a16.99 16.99 0 00-17.356-.986C8.62 11.161 5.166 16.828 5.17 23H0C0 14.773 4.696 7.25 12.136 3.562c7.44-3.689 16.349-2.91 23.02 2.01L38.421.16a.332.332 0 01.612.131l1.606 14.154a.324.324 0 01-.095.267.333.333 0 01-.27.094l-14.32-1.588a.325.325 0 01-.132-.605zM5.578 45.84l3.267-5.413c6.67 4.925 15.58 5.706 23.022 2.017C39.31 38.755 44.005 31.229 44 23h-5.17c-.001 6.17-3.456 11.832-8.976 14.712a16.997 16.997 0 01-17.352-.979l5.675-3.346a.325.325 0 00-.133-.604l-14.32-1.588a.333.333 0 00-.27.094.324.324 0 00-.094.267L4.966 45.71a.332.332 0 00.612.13z"
              id="Shape"
            />
          </g>
        </g>
      </symbol>
    ) : null}
    {/* Social */}
    {all || social || twitter ? (
      <symbol viewBox="0 0 32 32" id="icon-twitter">
        <path
          d="M32 6.371c-1.16.525-2.139.542-3.177.023 1.34-.811 1.4-1.38 1.884-2.916a12.91 12.91 0 0 1-4.115 1.596A6.431 6.431 0 0 0 21.864 3c-3.578 0-6.479 2.94-6.479 6.564 0 .515.058 1.016.167 1.496C10.167 10.787 5.394 8.173 2.2 4.2a6.612 6.612 0 0 0-.879 3.302 6.584 6.584 0 0 0 2.883 5.463 6.402 6.402 0 0 1-2.934-.82l-.001.082c0 3.18 2.234 5.833 5.198 6.437a6.43 6.43 0 0 1-2.927.112c.825 2.607 3.218 4.505 6.052 4.559A12.903 12.903 0 0 1 0 26.052 18.167 18.167 0 0 0 9.93 29c11.919 0 18.433-10.001 18.433-18.675 0-.286-.004-.566-.017-.85C29.61 8.551 31.132 7.69 32 6.371"
          fill="currentColor"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}

    {all || account ? (
      <symbol viewBox="0 0 20 20" id="icon-account">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm2.5 4a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM6.026 18.854c-.213.596-.276 1.019-.276 1.146h-1.5c0-.373.124-.981.364-1.651a9.01 9.01 0 0 1 1.22-2.295C7.011 14.463 8.97 13 12 13c3.03 0 4.99 1.463 6.166 3.054a9.008 9.008 0 0 1 1.22 2.295c.24.67.364 1.278.364 1.651h-1.5c0-.127-.063-.55-.276-1.146a7.514 7.514 0 0 0-1.015-1.908C16.011 15.662 14.47 14.5 12 14.5c-2.47 0-4.01 1.162-4.96 2.446a7.51 7.51 0 0 0-1.014 1.908z" fill="currentColor"></path>
      </symbol>
    ) : null}

    {all || social || email ? (
      <symbol viewBox="0 0 32 32" id="icon-email">
        <g fill="currentColor" fillRule="evenodd">
          <path d="M16.086 17.334L30.627 6.502A3.267 3.267 0 0 0 28.885 6h-25.6c-.621 0-1.194.177-1.685.47l14.486 10.864z" />
          <path d="M16.464 18.857a.805.805 0 0 1-.931-.002L.413 7.538C.158 7.98 0 8.478 0 9.018v13.847c0 1.695 1.435 3.077 3.2 3.077h25.6c1.765 0 3.2-1.382 3.2-3.077V9.018c0-.518-.147-1-.382-1.429L16.464 18.857z" />
        </g>
      </symbol>
    ) : null}
    {all || social || whatsapp ? (
      <symbol viewBox="0 0 32 32" id="icon-whatsapp">
        <path
          d="M22.189 24.818c-.856.078-.856.701-5.6-1.165-4.74-1.868-7.733-6.732-7.967-7.044-2.187-2.91-2.762-5.991-.273-8.715.79-.86 2.748-.824 3.19.235.387.934 1.32 3.229 1.438 3.462.117.235.194.507.037.817-.186.375-.38.814-1.166 1.596-.233.233-.475.484-.203.95.272.468 1.206 1.995 2.594 3.231 1.782 1.59 3.284 2.081 3.75 2.315.467.233.74.195 1.012-.117.271-.313 1.167-1.362 1.476-1.829.312-.467.624-.388 1.05-.233.428.155 2.72 1.283 3.188 1.518.466.23.778.35.895.544.701 1.177-.963 4.212-3.421 4.435M16 0C7.178 0 0 7.177 0 16c0 3.5 1.133 6.744 3.048 9.38L1.05 31.324l6.149-1.97A15.897 15.897 0 0 0 16 32c8.821 0 16-7.177 16-16 0-8.822-7.178-16-16-16"
          fill="currentColor"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || social || facebook ? (
      <symbol viewBox="0 0 32 32" id="icon-facebook">
        <path
          d="M18.7 17.4h5.1l.7-5.6h-5.8V8.1c0-1.6.5-2.7 2.8-2.7h3V.2c-.5 0-2.3-.2-4.4-.2-4.4 0-7.9 2.7-7.9 7.7v4.1H7.6v5.6h4.6V32h6.5V17.4z"
          fill="currentColor"
        />
      </symbol>
    ) : null}
    {all || social || google ? (
      <symbol viewBox="0 0 32 32" id="icon-google">
        <path
          d="M28.6 14.6v-3.4H26v3.4h-3.4v2.6H26v3.4h2.6v-3.4H32v-2.6zm-8-.6a8.2 8.2 0 0 1 .2 2.2c0 5.9-4 10.3-10.2 10.3A10.65 10.65 0 0 1 0 16 10.65 10.65 0 0 1 10.6 5.5a10.48 10.48 0 0 1 7.2 2.8l-3 3A6.38 6.38 0 0 0 4.2 16a6.24 6.24 0 0 0 6.4 6.3c3.2 0 5.4-1.8 5.8-4.3h-5.8v-3.9l10-.1z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || social || instagram ? (
      <symbol viewBox="0 0 32 32" id="icon-instagram">
        <g stroke="currentColor" fill="currentColor">
          <path
            d="M8.5 2.9h15c1.6 0 3 .7 3.9 1.7 1 .9 1.7 2.3 1.7 3.9v15c0 1.6-.7 3-1.7 3.9-.9 1-2.3 1.7-3.9 1.7h-15c-1.6 0-3-.7-3.9-1.7-1-.9-1.7-2.3-1.7-3.9v-15c0-1.6.7-3 1.7-3.9.9-1.1 2.3-1.7 3.9-1.7m15-1.9h-15C4.4 1 1 4.4 1 8.5v15C1 27.6 4.4 31 8.5 31h15c4.1 0 7.5-3.4 7.5-7.5v-15C31 4.4 27.6 1 23.5 1"
            strokeWidth="2"
          />
          <path
            d="M16 21c-1.4 0-2.6-.6-3.5-1.5-.9-.9-1.5-2.1-1.5-3.5s.6-2.6 1.5-3.5c.9-.9 2.2-1.5 3.5-1.5 1.4 0 2.6.6 3.5 1.5.9.9 1.5 2.2 1.5 3.5 0 1.4-.6 2.6-1.5 3.5-.9.9-2.1 1.5-3.5 1.5m0-12c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7"
            strokeWidth="2"
          />
          <path d="M24 9.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5m0-4c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5" />
        </g>
      </symbol>
    ) : null}
    {/* Loaders */}
    {all || loaders || loaderCT ? (
      <symbol viewBox="0 0 50 60" id="icon-loading-ct">
        <path
          d="M18.244 19.205L16.378 20.5l-1.072-1.296L39.152 0c.285 1.58 1.219 6.812 4.092 6.31 2.152-.364 4.166-3.013 5.32-4.73H50c-.65 2.008-1.363 3.79-2.662 5.515-1.293 1.653-2.802 3.014-4.524 4.156-1.29.867-2.298 1.361-3.807 1.79l-.073 34.255c.787-.639 1.51-1.28 2.151-2.073 1.372-1.507 2.38-3.224 3.45-4.876l1.154.428c-1.226 3.37-2.445 6.813-4.669 9.745-2.37 3.085-5.675 6.1-9.273 7.67-2.508 1.151-6.033 1.653-8.76 1.79C12.138 60.418 3.158 53.324.86 42.786A42.985 42.985 0 0 1 0 34.182c.073-4.722 2.014-9.38 4.376-13.397 3.378-5.872 8.842-10.538 15.022-13.471 2.444-1.15 5.31-2.22 8.111-2.22.293 0 .723.066.861.35.073.145-.064.363-.21.363-2.729 1.07-3.306 1.143-5.815 2.795-2.452 1.645-4.815 3.37-6.617 5.662-4.523 5.59-5.886 12.968-5.1 20 .365 3.215 1.438 6.438 3.24 9.16 1.218 1.799 2.801 3.16 4.376 4.52v-28.74zm3.622 29.331c2.444 1.15 4.816 2.3 7.543 2.3 1.73.066 3.662 0 5.318-.648.577-.29 1.143-.712 1.721-1.077l.074-36.977-4.313-3.013-1.217 25.515c-.074 2.51-1.145 4.95-2.37 7.096-1.007 1.725-2.59 3.15-4.094 4.448-.86.72-1.72 1.506-2.662 2.356z"
          fill="#0A1633"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || loaders || loaderSMH ? (
      <symbol viewBox="0 0 59 62" id="icon-loading-smh">
        <path
          d="M44.28 48.294c-4.229-3.036-9.12-5.265-13.698-6.539l-.124-.041 5.043-7.53c6.429 1.401 10.814 4.95 10.814 8.611 0 1.632-.746 3.81-1.975 5.418l-.06.08zM32.557 23.685c-.886-.123-3.722-.609-4.415-.766-2.306-.477-13.809-3.888-13.809-8.981 0-5.786 7.435-5.786 11.005-5.786.788 0 9.162.732 13.111 6.18-.041.078-4.838 7.711-5.892 9.353zm25.235-7.84l.115-.094c.566-.544 1.093-1.66 1.093-2.327 0-.776-.285-1.484-.799-2-.497-.565-1.268-.885-2.288-.96-.087-.006-.584-.03-.617-.03-2.5.024-5.195 1.598-8.038 4.36-2.497 2.425-3.438 4.221-5.015 6.71-1.28 2.024-1.892 2.98-2.235 3.528-.481-.06-3.38-.518-5.976-1.083.836-1.36 3.303-5.693 6.102-9.745 2.035-2.945 4.496-5.61 5.73-7.129.193-.236.38-.375.605-.502.168-.095.417-.22.5-.315.009-.113-.327-.447-.385-.49-.166.022-.265.06-.405.129-.191.09-.447.215-.801.215-.451 0-.916-.384-1.761-1.083C41.495 3.27 37.543.012 30.598 0 18.702-.018 11.679 10.125 11.767 16.839c.055 4.183.854 8.78 2.94 10.712 2.128 1.97 5.712 3.41 11.98 4.9l.421.11-1.005 1.117c-1.649 1.405-2.834 2.755-5.925 2.831-1.955 0-2.866-.669-3.566-1.296l-.147.062c.163.329.59 1.063 1.14 1.739.704.857 1.35 1.306 1.93 1.336.095.025.914.234 2.238-.179 1.71-.534 3.556-1.817 5.338-3.824l.688-.771.69-.769 4.475.799c.511.116 1.015.173 1.457.303l-1.843 2.806c-2.325 3.51-3.214 4.605-3.214 4.605s-1.551-.224-1.96-.303c-1.276-.255-3.283-.382-6.06-.359-5.432-.05-12.938 1.959-17.463 6.469a13.529 13.529 0 0 0-2.288 2.996A11.737 11.737 0 0 0 0 56.078C0 58.81 1.798 62 6.876 62c6.794 0 12.706-6.42 15.824-9.872l.5-.556c.928-1.019 1.353-1.732 1.692-2.095 3.593.995 9.43 3.433 14.54 6.786 1.038-1.058 4.088-4.69 6.947-8.944 1.568-2.334 5.184-7.758 5.313-11.921.126-3.987-3.603-8.775-10.497-10.197.221-.458.633-1.162 1.667-2.762 2.834-4.392 5.39-8.96 10.78-8.96.964 0 2.969.22 4.055 2.24.032.046.05.076.095.127zM17.445 55.863c-1.312 1.119-2.63 2.065-3.922 2.816-1.358.747-2.686 1.296-4.021 1.63a11.6 11.6 0 0 1-2.799.38c-.256 0-.516-.015-.822-.042-2.755-.271-4.47-1.906-4.47-4.277 0-6.279 10.526-8.23 14.361-8.23l.808-.005c1.756-.014 2.985.111 6.431.806l.723.192a46.746 46.746 0 0 1-5.011 5.552c-.435.407-.84.806-1.278 1.178z"
          fill="#0A1633"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || loaders || loaderWaToday ? (
      <symbol viewBox="0 0 60 41" id="icon-loading-watoday">
        <path
          d="M29.974 11.33h-.334c-.611 1.626-10.344 27.707-10.566 28.269-.22.618-.5 1.401-1.389 1.401-.611 0-.946-.449-1.167-1.12L4.007 4.318C3.45 2.746 2.448 2.297 1.725 2.297H.335C.055 2.297 0 2.074 0 1.85V.392C0 .112.056 0 .445 0c.445 0 2.17.166 7.897.166C12.347.166 14.624 0 15.18 0c.389 0 .446.166.446.447V1.85c0 .28-.057.447-.446.447h-1.223c-.89 0-1.446.788-1.112 1.91l7.62 24.453h.331c.668-1.906 7.34-19.744 7.34-21.763 0-1.403-.556-2.86-1.053-3.53-.502-.675-1.225-1.07-1.67-1.07h-1.112c-.279 0-.335-.113-.335-.447V.392c0-.226.056-.392.39-.392.502 0 2.449.166 7.34.166 4.67 0 6.784-.166 7.34-.166.334 0 .386.166.386.502v1.403c0 .224-.052.392-.385.392h-1.67c-.889 0-1.39 1.235-1.11 2.189l7.673 24.174h.333c2.728-7.627 7.564-21.874 7.564-24.904 0-.617-.723-1.459-1.78-1.459h-1.612c-.335 0-.392-.168-.392-.504v-1.4c0-.227.057-.393.446-.393.555 0 2.504.166 5.95.166C57.555.166 59.167 0 59.61 0c.336 0 .389.111.389.502v1.403c0 .224 0 .392-.389.392h-1.054c-.946 0-2.058.62-2.614 2.02-.668 1.796-11.846 32.252-12.958 34.946-.277.673-.667 1.737-1.669 1.737-.779 0-1.11-.728-1.389-1.51l-9.953-28.16"
          fill="#0A1633"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || loaders || loaderTheAge ? (
      <symbol viewBox="0 0 61 56" id="icon-loading-theage">
        <path
          d="M55.49 51.65a76.398 76.398 0 0 1-3.368-6.912L32.98 0h-4.86L16.7 28.195c-1.56 3.883-9.118 21.282-10.102 23.07-1.2 2.15-2.076 1.862-6.598 2.25V56c1.642-.077 6.268-.232 9.143-.232 2.547 0 5.093.155 7.394.232v-2.486c-6.16-.077-6.736-.387-6.736-1.24 0-.312.33-1.244.74-2.332l4.503-11.435c.494-1.165.741-1.398 1.808-1.398h18.65c1.481 0 1.645 0 2.137 1.165l4.953 12.367c.328.776.575 1.475.575 1.941 0 .39-.575.778-7.394.932V56c6.407-.154 9.2-.232 12.242-.232 4.435 0 9.37.078 12.985.232v-2.64c-3.184 0-4.771-.388-5.51-1.71zM35.61 34.391c0 .233-.411.466-.984.544H18.151c-1.151 0-1.48-.233-1.48-.466s.166-.544.329-1.088l8.973-22.253c.246-.466.33-.854.494-.854.162 0 .41.388.493.7l.047.116 8.274 22.291c.245.622.328.777.328 1.01z"
          fill="#0A1633"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
    {all || loaders || loaderBrisbaneTimes ? (
      <symbol viewBox="0 0 47 62" id="icon-loading-bt">
        <path
          d="M25.33 53.374c-3.825 0-7.729-1.627-10.519-5.29V33.278c2.312-4.556 6.774-6.51 10.678-6.51 7.17 0 11.712 6.349 11.712 13.183 0 6.427-3.824 13.424-11.872 13.424m1.99-35.23c-4.38 0-9.479 1.79-12.508 5.776V0H0v8.782l5.172.34v51.9h8.764l.48-4.882C17.44 60.21 22.698 62 27.162 62 38.873 62 47 51.666 47 40.193c0-12.285-8.445-22.048-19.68-22.048"
          fill="#0A1633"
          fillRule="evenodd"
        />
      </symbol>
    ) : null}
  </svg>
);

SvgIcons.defaultProps = {
  all: false,
  // utilities
  utilities: false,
  loading: false,
  crop: false,
  search: false,
  warnin: false,
  carat: false,
  tick: false,
  validationAlert: false,
  filter: false,
  edit: false,
  cycle: false,
  // social
  social: false,
  account: false,
  twitter: false,
  email: false,
  whatsapp: false,
  facebook: false,
  google: false,
  instagram: false,
  // loaders
  loaders: false,
  loaderSMH: false,
  loaderTheAge: false,
  loaderWaToday: false,
  loaderBrisbaneTimes: false,
  loaderCT: false
};

export default SvgIcons;
